import React from 'react';
import LoginForm from '../organisms/LoginForm';
import { login } from '../redux/slice/login/loginSlice';
import { useDispatch } from 'react-redux';

const LoginPage = () => {
  const dispatch = useDispatch();
  const handleLogin = (data) => {
    dispatch(login(data));
  };

  return <LoginForm onSubmit={handleLogin} />;
};

export default LoginPage;
